<template>
  <tbody>
    <tr class="bg-gray-100">
      <td class="px-4 py-3 border border-gray-400 text-center">
        <input type="checkbox" v-model="selectAll" :disabled="disabled" />
      </td>
      <td class="px-4 py-3 border border-gray-400">
        {{ notificationSetting.name }}
      </td>
      <slot />
    </tr>
  </tbody>
</template>

<script>
export default {
  name: 'TableBody',
  props: {
    notificationSetting: { type: Object, required: true },
    userNotificationSettings: { type: Array, required: true },
    disabled: Boolean,
  },
  computed: {
    filtered() {
      return this.userNotificationSettings.filter(
        (x) => x.notificationSettingCode === this.notificationSetting.code
      );
    },
    selected() {
      return this.filtered.filter((x) => x.isEnabled);
    },
    selectAll: {
      get() {
        return this.selected.length === this.filtered.length;
      },
      set(select) {
        this.filtered.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.isEnabled = select;
        });
      },
    },
  },
};
</script>
